<template>
  <div style="display: flex; flex-direction: column;">
    <main-swiper></main-swiper>
    <div class="rankList">
      <div v-for="(item,sort) in topNav" :key="'a'+sort" class="ranklist-wrap">
        <div class="rank-header" :id="item.anchorPoint" :name="item.anchorPoint">
          {{ item.name }}
        </div>
        <div class="rankCon">
          <li v-for="(item, index) in dataList[sort]" :key="index"
            :class="[(index + 1) % 4 == 0 ? 'item-noMargin' : '', 'vitem-item']" @click="navToDetail(item.comicId)">
            <div class="vitem-cover">
              <p :class="[index < 3 ? '' : 'huise']">TOP{{index+1}}</p>
              <img  @dragstart.prevent  :src="item.realCoverUrl" alt="" class="vitem-cover-img" />
            </div>
            <p class="vitem-name">{{ item.comicName }}</p>
          </li>
        </div>
      </div>
      <div class="miaodian"  :style="{display:isShowMiaodian ? 'flex':'none'}" id="miaodian">
        <p class="suoyin">索引</p>
        <div class="bang">
          <div :class="index == vactive ? 'active-bang bang-con' : 'bang-con'" v-for="(item, index) in topNav"
            :key="'b'+index" @click="handleAct(item.id, item.anchorPoint)">
            {{ item.name }}
            <!-- <a :href="`#${item.anchorPoint}`">{{ item.name }}</a> -->
          </div>
          <p class="fenge"></p>
          <div class="reback" @click="handleAct(0, 'anchorPoint_0')"><img  @dragstart.prevent  src="../assets/icon_fanhuidingbu.png" alt="" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import MainSwiper from '../components/mainSwiper.vue'
import {homeRankList} from '@/utils/api'
import { toRefs, toRaw, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { navToDetail } from '../utils/utils'
const router = useRouter();
const props = defineProps({});
let dataList = ref([])
let vactive = ref(0);
let topNav = ref([]);
let isShowMiaodian = ref(false);

onMounted(() => {
  homeRankList().then(res=>{
    let titList = []
    let conList = []
    let list = res.data
    for (let i in list){
        titList.push({name:list[i].columnName,anchorPoint:`anchorPoint_${i}`,id:i})
        conList.push(list[i].comicShowVOList)
    }
    topNav.value = titList
    dataList.value = conList
  })
});
let handleAct = (index,name) => {
  vactive.value = index;
  // 获取对应的目标元素位置
  var target = document.getElementById(name);
  var offsetTop = target.offsetTop + 430;
  // 滚动到目标元素的位置
  window.scrollTo({
    top: offsetTop,
    behavior: 'smooth' // 平滑滚动
  });
};
window.addEventListener("scroll", function (e) {
  //变量scrollTop是滚动条滚动时，距离顶部的距离
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  //变量windowHeight是可视区的高度
  var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
  //变量scrollHeight是滚动条的总高度
  var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
  // console.log("距顶部" + scrollTop + "可视区高度" + windowHeight + "滚动条总高度" + scrollHeight);
  //滚动条到底部的条件
  if (scrollTop < 500) { //控制左侧章节导航
    isShowMiaodian.value = false
  } else {
    isShowMiaodian.value = true
  }
});

</script>

<style lang="scss" scoped>
.rankList {
  width: 1228px;
  height: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;


  .ranklist-wrap {
    width: 1228px;
    padding-right: 247px;
    box-sizing: border-box;
    margin: 0 auto;
    // background-color: lawngreen;
  }

  .rank-header {
    height: 40px;
    font-size: 28px;
    
    color: #333333;
    line-height: 40px;
    margin-bottom: 30px;
  }

  .rankCon {
    display: flex;
    flex-wrap: wrap;

    .vitem-item {
      margin: 0 47px 30px 0;
      cursor: pointer;
      .vitem-cover{
        position: relative;
        p:nth-child(1) {
          position: absolute;
          top: 7px;
          right: 7px;
          width: 60px;
          height: 24px;
          background: #FFD000;
          border-radius: 4px;
          text-align: center;
          line-height: 24px;
        }
        .huise{
          background-color: #E3E3E3 !important;
          color: #666666;
        }
      }
      .vitem-cover-img {
        width: 200px;
        height: 300px;
        border-radius: 10px;
      }
    }
    .vitem-item:hover{
      .vitem-cover{
        box-shadow: 0px 0px 8px 0px rgba(29, 30, 31, 0.3);
        border-radius: 10px;
      }
      .vitem-name{
        color: #CB2945;
      }
    }

    .item-noMargin {
      margin-right: 0;
    }

    .vitem-name {
      font-size: 18px;
      
      color: #333333;
      line-height: 25px;
      margin-top: 10px;
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .miaodian {
    width: 134px;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: fixed;
    right: 50%;
    z-index: 1;
    top: 160px; 
    margin-right: -600px;
    z-index: 999;
    .suoyin {
      width: 110px;
      height: 38px;
      background: #cb2945;
      border-radius: 28px;
      text-align: center;
      font-size: 18px;
      
      color: #ffffff;
      line-height: 38px;
      margin-bottom: 16px;
    }

    .bang {
      width: 134px;
      height: 192px;
      background: #ffffff;
      border-radius: 10px;
      border: 2px solid #e6e6e6;

      .bang-con {
        width: 110px;
        height: 36px;
        border-radius: 6px;
        text-align: center;
        line-height: 36px;
        font-size: 16px;
        font-weight: 400;font-weight: lighter;
        color: #cb2945;
        cursor: pointer;
        margin: 10px;
        // box-sizing: border-box;
      }

      .active-bang {
        background: rgba(203, 41, 69, 0.06);
      }
    }

    .fenge {
      width: 130px;
      border: 1px solid #e6e6e6;
    }

    .reback {
      height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      img {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
